import React from 'react';
import { CardWrapper, ContentStyles, ImageStyles, SpanStyles } from './focus-card-styles';
var FocusCard = function (_a) {
    var item = _a.item;
    return (React.createElement(CardWrapper, { size: item.size },
        React.createElement("a", { href: item.link, title: item.linkTitle },
            React.createElement(ImageStyles, { img: item.imageSrc }),
            React.createElement(ContentStyles, null,
                React.createElement(SpanStyles, null, item.title),
                React.createElement("br", null),
                React.createElement(SpanStyles, { subTitle: true }, item.subTitle)))));
};
export default FocusCard;
